import ApplicationController from './application_controller';

// Bulk-import the values from a prior visit note into the in-progress note,
// when both notes use the same custom-form template (so datum keys line up).
// Rendered by app/views/shared/form/widgets/_prior_note_preview.html.erb.
//
// Each item in itemsValue describes one field to write:
//   form_attr_id - DOM id of the form input on the new-note form (matches
//                  the parameterized "<model>[datum][<control_id>]" the new
//                  form partials produce).
//   kind         - "native" (text input / textarea) or "ckeditor".
//   value        - plain text for native, raw HTML for ckeditor.
//
// CKEditor instances are not exposed globally, but _body.html.erb wires every
// .wysiwyg-ckeditor div with an `auto-save-load` event listener that calls
// editor.setData(event.detail.data). We dispatch that same event to drive
// the import — no editor instance lookup needed.
export default class extends ApplicationController {
  static values = { items: Array };

  import(event) {
    event?.preventDefault();
    const items = Array.isArray(this.itemsValue) ? this.itemsValue : [];
    if (!items.length) return;

    let written = 0;
    items.forEach((item) => {
      if (!item || !item.form_attr_id) return;
      if (item.kind === 'ckeditor') {
        if (this.#writeToCkEditor(item.form_attr_id, item.value || '')) written += 1;
      } else {
        if (this.#writeToNative(item.form_attr_id, item.value || '')) written += 1;
      }
    });

    this.#flashConfirmation(written);
  }

  #writeToNative(formAttrId, value) {
    const el = document.getElementById(formAttrId);
    if (!el) return false;
    el.value = value;
    el.dispatchEvent(new Event('input',  { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  #writeToCkEditor(formAttrId, html) {
    // The ckeditor div mirrors the textarea id via data-id (see
    // app/views/shared/form/controls/standard/_wysiwyg_ckeditor.html.erb).
    const editorEl = document.querySelector(`.wysiwyg-ckeditor[data-id="${CSS.escape(formAttrId)}"]`);
    if (!editorEl) {
      // Fallback: at minimum update the underlying textarea so the value is
      // submitted even if the editor div hasn't initialized yet.
      const ta = document.getElementById(formAttrId);
      if (!ta) return false;
      ta.value = html;
      ta.dispatchEvent(new Event('input', { bubbles: true }));
      return true;
    }
    editorEl.dispatchEvent(new CustomEvent('auto-save-load', { detail: { data: html } }));
    return true;
  }

  #flashConfirmation(count) {
    const original = this.element.innerHTML;
    const wasDisabled = this.element.disabled;
    this.element.disabled = true;
    this.element.innerHTML = `<i class="bi bi-check2"></i> Imported ${count} field${count === 1 ? '' : 's'}`;
    setTimeout(() => {
      this.element.innerHTML = original;
      this.element.disabled = wasDisabled;
    }, 1500);
  }
}
